import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class MetaPixelService {
  private initialized = false;
  private lastTrackedUrl: string | null = null;

  init(): void {
    const pixelId = environment.metaPixelId;
    if (!pixelId || this.initialized || typeof window === 'undefined') {
      return;
    }

    this.bootstrapFbq();
    window.fbq?.('init', pixelId);
    this.initialized = true;
  }

  trackPageView(url: string): void {
    if (!this.initialized || !environment.metaPixelId || this.lastTrackedUrl === url) {
      return;
    }

    this.lastTrackedUrl = url;
    window.fbq?.('track', 'PageView');
  }

  private bootstrapFbq(): void {
    if (window.fbq) {
      return;
    }

    const fbq = function (this: FbqStub, ...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args);
      } else {
        fbq.queue.push(args);
      }
    } as FbqStub;

    if (!window._fbq) {
      window._fbq = fbq;
    }

    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript?.parentNode?.insertBefore(script, firstScript);
  }
}

interface FbqStub {
  (...args: unknown[]): void;
  queue: unknown[][];
  callMethod?: (...args: unknown[]) => void;
  push: FbqStub;
  loaded: boolean;
  version: string;
}

declare global {
  interface Window {
    fbq?: FbqStub;
    _fbq?: FbqStub;
  }
}
